import {
  GridDataResult,
  SelectableSettings
} from "@progress/kendo-angular-grid";
import { State } from "@progress/kendo-data-query";
import { GridDataEntity } from "../../grid-data-entity";
import { GridColumnDefinition } from "../../grid-column-definition";
import { FilterGroup } from "src/app/shared/DTO/filtering/filter-group";

export class KendoGridEntity {
  /**
   *
   */
  constructor() {
    this.state = {
      skip: 0,
      take: 50,
      filter: {
        filters: [],
        logic: "and"
      },
      sort: []
    };
    this.preFilter = new FilterGroup();
    this.selectableSettings = {
      enabled: true,
      mode: "single"
    };
    this.gridData = {
      data: [{}],
      total: 1
    };
  }

  public gridData: GridDataResult;

  public localData: GridDataEntity; // CONVERT this to a model, it will make things more strongly typed

  public state: State;

  public isDynamic: boolean;

  public columns: GridColumnDefinition[];

  public gridId: string;

  public gridName: string;

  public gridEntityName: string;

  public outOfDate: boolean;

  public lastRefresh: Date;

  public isLoading: boolean;

  public selectableSettings: SelectableSettings;

  public preFilter: FilterGroup;

  public includeHasDocuments?: boolean;

  public project?: string;

  public group?: string;

  public totalBeforeFiltering: number;

  public totalAfterFiltering: number;

  private StartDate() {
    this.lastRefresh = new Date();
  }

  public refreshGrid() {
    this.StartDate();
    if (this.gridId == null) {
      // Get information
    }
  }
}
